import React from 'react';
import PropTypes from 'prop-types';
import BlacklistQuickAction from '../utils/BlacklistQuickAction';

const UserAgentColumnField = ({ record = {} }) => (
    <BlacklistQuickAction
        value={record.user_agent}
        entityLabel="user agent"
        paramName="useragent"
        alreadyBlacklisted={record.blacklistedip === true}
        blacklistEndpoint="admin/douseragentblacklist"
        whitelistEndpoint="admin/dowhitelistuseragent"
        durationNote="wordt voor onbepaalde tijd geblacklist, tot je hem zelf weer verwijdert."
    />
);

UserAgentColumnField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
};

export default UserAgentColumnField;



// WEBPACK FOOTER //
// ./src/siteclicks/UserAgentColumnField.js